import _isNil from 'lodash/isNil';
import { getAllKeys } from './GlobalKeys';

export function clearGlobalVariable(variable: string, callback?: () => void) {
    window[variable] = null;

    if (callback) {
        callback();
    }
}

export function clearAllGlobalVariables(callback?: () => void) {
    const keys = getAllKeys();
    keys.forEach((key) => (window[key] = null));

    if (callback) {
        callback();
    }
}

export function addGlobalVariable(
    key: string,
    value: any,
    callback?: () => void
) {
    window[key] = value;

    if (callback) {
        callback();
    }
}

export function hasGlobalValue(key: string): boolean {
    return !_isNil(window[key]);
}

export function getGlobalVariable(key: string) {
    return window[key];
}
